import React from "react";
import { showLocalDate } from "../../../../utilities/functions";

const PaymentDate = ({ row }) => {
  return <div>{row?.paymentDate ? showLocalDate(row?.paymentDate) : ""}</div>;
};

export default PaymentDate;
